import {
  FormGroup,
  Input,
  InputV2,
  SelectInputV2Props,
} from '@southfields-digital/mpxlive-components';

import styles from './RundownTemplateForm.module.scss';

interface IRundownTemplateFormProps {
  state: Partial<RundownTemplate>;
  graphicsPackages: SelectInputV2Props['options'];
  stateUpdated: (state: Partial<RundownTemplate>) => void;
}

export default function RundownTemplateForm({
  state,
  graphicsPackages,
  stateUpdated,
}: IRundownTemplateFormProps) {
  const updateState = (newState: Partial<RundownTemplate>) => {
    if (!state) return;

    stateUpdated({ ...state, ...newState });
  };

  return (
    <div className={styles.RundownForm}>
      <Input
        label="Template name"
        value={state.name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          updateState({ name: e.currentTarget.value })
        }
      />

      <FormGroup label="Select graphics package" htmlFor="graphicsPackage">
        <InputV2
          type="select"
          inputSize="lg"
          id="graphicsPackage"
          value={state.graphicPackageId}
          options={graphicsPackages}
          placeholder="Pick a graphics package"
          onChange={(e) => {
            updateState({
              graphicPackageId: e.currentTarget.value,
              canvases: [],
            });
          }}
        />
      </FormGroup>
    </div>
  );
}
